// dashboard.state.ts
import { DashboardState, DashboardData } from "../dashboard.types";

const initialState: DashboardState = {
  data: null
};

export default initialState;
